const visibleColumns = [
  {
    title: "Position No",
    field: "NPOSITION_NO",
    locked: false,
    filter: "text",
    width: "180",
    show: true,
  },
  {
    title: "Title",
    field: "title",
    locked: false,
    filter: "text",
    width: "300",
    show: true,
  },


  {
    title: "Category Names",
    field: "CategoryNames",
    locked: false,
    filter: "text",
    width: "600",
    show: true,
  },

];

export default visibleColumns;
